import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { isReadyLang } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { setLocalStorage, removeLocalStorage } from '@/utils/localStorage';
import { localsList } from '@/utils/locals';
import { incompleteLocalsList } from '@/constants';

// 代理商网站
export const AGENT_SITE: any = {
    pl: 'https://ecoflow.com.pl/',
    se: 'https://ecoflow.se/',
    ch: 'https://ch.ecoflow.com/',
    ge: 'https://ge.ecoflow.com/', // 格鲁吉亚
    nl: 'https://www.ecoflow.nl/',
    nz: 'https://ecoflowtech.co.nz/',
    tr: 'https://ecoflow.com.tr/',
    pt: 'https://www.ecoflow.com.pt/', // 葡萄牙
    ie: 'https://www.ecoflow.ie/', // 爱尔兰
    cz: 'https://www.ecoflow.cz/', // 捷克
    hr: 'https://www.ecoflow.hr/', // 克罗地亚
    si: 'https://www.ecoflow.si/', // 斯洛文尼亚
    dk: 'https://www.ecoflow.dk/', // 丹麦
    no: 'https://www.ecoflow.no/',
    kz: 'https://ecoflow.com.kz/',
    gr: 'https://ecoflow.gr/',
};

export default function Region({ SEO }: any) {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');

    const tabsList = [
        { key: 'p1', text: t('region.region_asia_pacific'), id: 'asiaPacific' },
        { key: 'p2', text: t('region.region_north_america'), id: 'northAmerica' },
        { key: 'p3', text: t('region.region_europe'), id: 'europe' },
        { key: 'p4', text: t('region.region_europe_ad'), id: 'europe_ad' },
        { key: 'p5', text: t('region.region_africa_middleeast'), id: 'africa' },
        { key: 'p7', text: t('region.region_latin'), id: 'latin' },
        { key: 'p6', text: t('region.region_other'), id: 'other' },
    ];

    const changeRegion = async (locale: string, appId: number, acceptLanguage: string, region: string) => {
        // 代理商跳转
        const agent_site = AGENT_SITE[locale];
        if (agent_site) {
            window.open(agent_site);
            return;
        }
        if (isDisabledSite(locale)) return;

        removeLocalStorage('appInfo');
        setLocalStorage('languageRegion', region);
        setLocalStorage('appInfo', {
            appId,
            acceptLanguage,
            locale,
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'change_country',
            button_name: region,
        });
        window.location.href = `/${locale}`;
    };

    const isDisabledSite = (currLocal: string) => !isReadyLang(currLocal) || incompleteLocalsList.includes(currLocal);

    return (
        <PageLayout>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <div className={`${css.region} container`}>
                {tabsList.map((item: { key: string; text: string; id: string }) => (
                    <div className="lang-group" key={item.id}>
                        <div className="group-name" id={item.id}>
                            {item.text}
                        </div>
                        <ul className="member-list">
                            {localsList[item.id]?.map(
                                (list: any) =>
                                    (!list?.allowSites || list?.allowSites?.includes(locale)) && (
                                        <li
                                            className="member"
                                            key={list.region}
                                            onClick={() => changeRegion(list.local, list.appId, list.acceptLanguage, `${list.region}(${list.language})`)}
                                        >
                                            <span className={`region ${!isDisabledSite(list.local) || AGENT_SITE[list.local] ? '' : 'disabled'}`}>
                                                {list.regionText}
                                            </span>
                                            <span className={`lang ${!isDisabledSite(list.local) || AGENT_SITE[list.local] ? '' : 'disabled'}`}>
                                                {!isDisabledSite(list.local) || AGENT_SITE[list.local] ? list.languageText : t('region.comming_soon')}
                                            </span>
                                        </li>
                                    ),
                            )}
                        </ul>
                    </div>
                ))}
            </div>
        </PageLayout>
    );
}
